import "./App.css";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import Login from "./Auth/Login";
import GoogleSheets from "./Components/GoogleSheets";
import ActivePullRequestList from "./Components/ActivePullRequestList";
import TaskList from "./Components/TaskList";
import EnvironmentCICDVertical from "./Components/EnvironmentCICDVertical";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userData, setUserData] = useState(null); // To store user details

    useEffect(() => {
        // Check if token exists in cookies
        const token = Cookies.get("authToken");
        if (token) {
            setIsAuthenticated(true);
            setUserData(JSON.parse(Cookies.get("userData") || "{}")); // Load user data if available
        }
    }, []);

    const handleLogin = (username, password) => {
        // Simulate checking credentials (not secure, just for demo)
        const validUsername = process.env.REACT_APP_USERNAME;
        const validPassword = process.env.REACT_APP_PASSWORD;

        if (username === validUsername && password === validPassword) {
            // Save token in cookies for 12 hours
            Cookies.set("authToken", "your-secure-token", { expires: 0.5 });
            setIsAuthenticated(true);
            toast.success("Successfully logged in!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            toast.error("Invalid username or password", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleGoogleLogin = (userData) => {
        // Save token and user data in cookies
        Cookies.set("authToken", "google-auth-token", { expires: 0.5 });
        Cookies.set("userData", JSON.stringify(userData), { expires: 0.5 });
        setIsAuthenticated(true);
        setUserData(userData);

        toast.success(`Welcome, ${userData.name}!`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    return (
        <div className="App">
            {isAuthenticated ? (
                <div>
                    <h1 className="text-3xl font-bold mb-4">
                        Welcome, {userData?.name || "User"}!
                    </h1>
                    <div className="flex space-x-4">
                        <ActivePullRequestList className="h-[44rem] overflow-y-auto w-1/3" />

                        <TaskList className="h-[44rem]" />
                        {/* <GoogleSheets className="h-[44rem]"/> */}
                        <EnvironmentCICDVertical />
                    </div>
                </div>
            ) : (
                <Login
                    onLogin={handleLogin}
                    onGoogleLogin={handleGoogleLogin}
                />
            )}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default App;
